export default __webpack_public_path__ + "static/media/tokyo_skytree.268f5160.jpeg";